//Media & Text Gallery

var mediaTextGallery = $('.media-text-gallery');

if (mediaTextGallery.length > 0) {
  var mediaTextGalleryImages = $('.media-text-gallery-images');
  var mediaTextGalleryImagesNav = $('.media-text-gallery-images-nav');
  mediaTextGalleryImages.slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.media-text-gallery-images-nav'
  });

  mediaTextGalleryImagesNav.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.media-text-gallery-images',
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
          asNavFor: '.media-text-gallery-images',
          variableWidth: true,
        }
      }
    ]
  });

  $(window).on('load resize changeorientaion', function () {
    $('.media-text-gallery-thumb').each(function () {
      $(this).css("background-image", "url(" + $(this).data("bg-image") + ")");
    });
  });
}
